export default __webpack_public_path__ + "static/banner-portal-fd03e4f44d7cb32a3436c2fa39d4b9c4.webp";